var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-container" }, [
    _c("div", { staticStyle: { "margin-bottom": "4em" } }, [
      _c("div", { staticClass: "form-header" }, [
        _c(
          "div",
          [
            _c("sui-button", {
              attrs: {
                basic: "",
                size: "mini",
                color: "blue",
                floated: "right",
                content: "Return to Attestations",
              },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "attestationManager" })
                },
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        [
          _c(
            "sui-container",
            { staticClass: "attestation-form-container" },
            [
              _c("MasterForm", {
                ref: "attestationForm",
                attrs: {
                  firm: _vm.firm,
                  "is-new-attestation": _vm.isNewAttestation,
                  attestation: _vm.defaultAtt,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-action-buttons" },
        [
          _c(
            "sui-container",
            [
              _c("sui-button", {
                attrs: {
                  primary: "",
                  type: "button",
                  size: "small",
                  floated: "right",
                  content: "Submit",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.handleSubmit.apply(null, arguments)
                  },
                },
              }),
              _c("sui-button", {
                attrs: {
                  basic: "",
                  type: "button",
                  size: "small",
                  color: "grey",
                  floated: "right",
                  content: "Cancel",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.handleCancel.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }